const TAG_CLS = { green: 'tag-green', amber: 'tag-amber', red: 'tag-red' };

export default function BriefDataTable({ rows = [] }) {
  return (
    <div className="brief-data">
      {rows.map((row, i) => (
        <div key={i} className="bd-row">
          <div className="bd-lbl">{row.label}</div>
          <div className="bd-val">{row.value}</div>
          {row.badge && (
            <div className="bd-badge">
              <span className={TAG_CLS[row.badge.color] ?? 'tag-amber'}>
                {row.badge.text}
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
